module.exports = {
  nav:{
    language: "简体中文",
    search:'搜索 天鑫'
  },
  readmore:'了解更多',
  showed:'已展示',
  product:'项',
  all:'共',
  loadmore:'加载更多'
 
  // homeright:{
  //   title: '_this.getValue(x, "home-rightproduct-title").value_en',
  //   subtitle: '_this.getValue(x, "home-rightproduct-subtitle").value_en',
  //   button: '_this.getValue(x, "home-rightproduct-button").value_en',
  //   buttonurl: '_this.getValue(x, "home-rightproduct-buttonurl").value_en',
  // }

};
